import { inject, Provider } from '@angular/core';
import { ConfigService } from '@rxap/config';
import { FlexsearchWorkerService } from './flexsearch-worker.service';
import { FLEXSEARCH_WORKER } from './flexsearch-worker.token';

/**
 * Provides the dedicated FlexSearch worker. The worker is created lazily on
 * first injection of {@link FlexsearchWorkerService}, and only when Web
 * Workers are supported *and* FlexSearch is enabled
 * (`search.flexsearch.enabled`) — so a deployment without local search
 * spawns no worker at all.
 *
 * Deliberately kept in the `shared/search` folder — separate from
 * `shared/workers/provide.ts` — so that wiring it into the eager app
 * config does not pull that file's `@xenova/transformers`-backed worker
 * imports into the main bundle (see `ipfs-worker.provider.ts` for the same
 * reasoning).
 */
export function provideFlexsearchWorker(): Provider[] {
  return [
    FlexsearchWorkerService,
    {
      provide: FLEXSEARCH_WORKER,
      useFactory: () => {
        const config = inject(ConfigService);
        return typeof Worker !== 'undefined' && config.get('search.flexsearch.enabled', false)
          ? new Worker(new URL('../../shared/workers/flexsearch.worker', import.meta.url))
          : null;
      },
    },
  ];
}
